import { render, staticRenderFns } from "./ImportItemFileModal.vue?vue&type=template&id=c5bf9fa0"
import script from "./ImportItemFileModal.vue?vue&type=script&lang=js"
export * from "./ImportItemFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5bf9fa0')) {
      api.createRecord('c5bf9fa0', component.options)
    } else {
      api.reload('c5bf9fa0', component.options)
    }
    module.hot.accept("./ImportItemFileModal.vue?vue&type=template&id=c5bf9fa0", function () {
      api.rerender('c5bf9fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/ImportItemFileModal.vue"
export default component.exports